import { Navigate, Route, Routes } from "react-router";
import { useSession } from "@/auth/SessionProvider";
import { SignIn } from "@/auth/SignIn";
import { Sidebar } from "@/components/Sidebar";
import { QuestsPage } from "@/routes/QuestsPage";
import { SkillsPage } from "@/routes/SkillsPage";
import { TagsPage } from "@/routes/TagsPage";
import { TemplateNewPage } from "@/routes/TemplateNewPage";
import { TemplatePage } from "@/routes/TemplatePage";
import { TopicsPage } from "@/routes/TopicsPage";
import { TraitsPage } from "@/routes/TraitsPage";
import styles from "./AppShell.module.css";

// The gate here is only what the person sees. Nothing is protected by it: the
// bundle is public and every read goes through the function, which refuses a
// request without an editor identity of its own.
export const App = () => {
  const { session, isLoading } = useSession();

  if (isLoading) {
    return null;
  }

  if (!session) {
    return <SignIn />;
  }

  return (
    <div className={styles.shell}>
      <Sidebar />
      <main className={styles.content}>
        <Routes>
          <Route path="/" element={<Navigate to="/skills" replace />} />
          <Route path="/skills" element={<SkillsPage />} />
          <Route path="/topics" element={<TopicsPage />} />
          <Route path="/tags" element={<TagsPage />} />
          <Route path="/traits" element={<TraitsPage />} />
          <Route path="/quests" element={<QuestsPage />} />
          <Route
            path="/quests/templates/new"
            element={<TemplateNewPage />}
          />
          <Route path="/quests/templates/:id" element={<TemplatePage />} />
          <Route path="*" element={<Navigate to="/skills" replace />} />
        </Routes>
      </main>
    </div>
  );
};
